export default __webpack_public_path__ + "static/media/m-signup-16-tour-pg-3.09246b6e.jpg";